import { injectable, inject } from 'inversify';
import { TYPES } from '@/Framework/config/DI/types';
import { DomainConfig } from '@/Framework/config/DI/DomainConfig';
import { IConfig } from '../IConfig';
import config from '../config';

@injectable()
class ConfigFactory {
  constructor(
    @inject(TYPES.DomainConfig) private domain: DomainConfig,
  ) {}

  create(): IConfig {
    return {
      ...config,
      hostname: this.domain.creditflowresearchDomain,
      newissueEmail: `newissue@${ this.domain.globalDomain }`,
      api: {
        ...config.api,
        external: `${ this.domain.protocol }//${ this.domain.globalDomain }`,
      },
    };
  }
}

export default ConfigFactory;
